/* MyPetClub Futterrechner und Futter-Check
 * Datenquelle: Produkt-Metafeld custom.futter_check (JSON), von der Section als JSON ausgegeben.
 * Keine externen Abhängigkeiten, keine Cookies. Zustand nur in sessionStorage.
 */
(function () {
  'use strict';
  var root = document.querySelector('.mpc-fc');
  if (!root) return;
  var app = root.querySelector('.mpc-fc__app');
  var dataEl = root.querySelector('script[data-mpc-fc-data]');
  if (!app || !dataEl) return;

  /* ===== DATEN ===== */
  var raw;
  try { raw = JSON.parse(dataEl.textContent); } catch (e) { raw = { recipes: [] }; }
  function slug(t) { return String(t).toLowerCase().replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  var DEFAULT_KCAL = 3700; // Fallback, wenn für eine Sorte kein ME-Wert hinterlegt ist
  var RECIPES = (raw.recipes || []).map(function (r) {
    var f = r.fc || {};
    return {
      id: r.id, key: slug(f.name || r.id), url: r.url, price: r.price, image: r.image,
      name: f.name || r.id, line: f.line || '',
      proteins: Array.isArray(f.proteins) ? f.proteins : null,
      grainFree: typeof f.grain_free === 'boolean' ? f.grain_free : null,
      single: !!f.single, cold: !!f.cold, vegan: !!f.meatfree, high: !!f.high, purin: !!f.purin,
      stages: Array.isArray(f.stages) ? f.stages : ['adult', 'senior'],
      kcal: f.kcal > 0 ? f.kcal : DEFAULT_KCAL, est: !(f.kcal > 0),
      order: typeof f.order === 'number' ? f.order : 999
    };
  }).sort(function (a, b) { return a.order - b.order; });

  var PROT_LABEL = { gefluegel: 'Geflügel', lamm: 'Lamm', fisch: 'Fisch', rind: 'Rind', insekt: 'Insekten', hirsch: 'Hirsch' };
  var AGE_LABEL = { puppy: 'Welpe/Junghund', adult: 'erwachsen', senior: 'Senior' };
  var ACT_LABEL = { low: 'ruhig', mid: 'alltagsaktiv', high: 'sportlich' };
  var SHAPE_LABEL = { lean: 'eher schlank', ideal: 'ideal', heavy: 'etwas zu viel' };

  /* ===== LOGIK ===== */
  function dailyKcal(a) {
    var rer = 70 * Math.pow(a.weight, 0.75);
    var f;
    if (a.age === 'puppy') f = 2.0;
    else if (a.age === 'senior') f = a.neutered ? 1.4 : 1.6;
    else f = a.neutered ? 1.6 : 1.8;
    if (a.age !== 'puppy') {
      if (a.activity === 'low') f -= 0.2;
      if (a.activity === 'high') f += 0.4;
    }
    if (a.shape === 'lean') f += 0.2;
    if (a.shape === 'heavy') f -= 0.3;
    f = Math.min(3.0, Math.max(1.0, f));
    return Math.round(rer * f / 10) * 10;
  }
  function gramsFor(kcal, kcalPer100) { return kcalPer100 > 0 ? Math.round(kcal / kcalPer100 * 100 / 5) * 5 : 0; }
  function dailyGrams(kcal, r) { return gramsFor(kcal, r.kcal / 10); }

  function calcAll(s) {
    var out = {};
    ['low', 'mid', 'high'].forEach(function (act) {
      var kcal = dailyKcal({ age: s.age, weight: s.weight, neutered: s.neutered, activity: act, shape: s.shape });
      var treatKcal = s.treats ? kcal * 0.1 : 0;
      var main = kcal - treatKcal;
      var dryKcal = main * s.dryShare / 100, wetKcal = main - dryKcal;
      var dry = gramsFor(dryKcal, s.dryKcal), wet = gramsFor(wetKcal, s.wetKcal), treat = gramsFor(treatKcal, s.treatKcal);
      out[act] = { kcal: kcal, dry: dry, wet: wet, treat: treat, cost: dry / 1000 * s.dryPrice + wet / 1000 * s.wetPrice };
    });
    return out;
  }

  function rank(a) {
    var out = [];
    RECIPES.forEach(function (r) {
      if (r.stages.indexOf(a.age) < 0) return;
      var s = 50, why = [], warn = [];
      if (a.age === 'puppy') why.push('Für Welpen und Junghunde');
      var sens = a.digest.indexOf('stomach') >= 0 || a.digest.indexOf('intol') >= 0;
      if (sens && r.single) { s += 20; why.push('Ein Protein, übersichtliche Zutaten'); }
      if (a.digest.indexOf('purin') >= 0) { if (r.purin) { s += 100; why.push('Purinarm'); } }
      else if (r.purin) s -= 15;
      if (a.activity === 'high' && r.high) { s += 25; why.push('Proteinreich für aktive Hunde'); }
      if (a.wish.indexOf('single') >= 0 && r.single) { s += 25; why.push('Single-Protein'); }
      if (a.wish.indexOf('cold') >= 0 && r.cold) { s += 25; why.push('Kaltgepresst'); }
      if (a.wish.indexOf('vegan') >= 0 && r.vegan) { s += 60; why.push('Fleischfrei'); }
      var ex = a.excl.filter(function (x) { return x !== 'grain'; });
      ex.forEach(function (x) {
        if (r.proteins === null) { s -= 40; warn.push('Zutatenliste auf ' + PROT_LABEL[x] + ' prüfen'); }
        else if (r.proteins.indexOf(x) >= 0) { s -= 1000; }
      });
      if (ex.length && r.proteins !== null && s > -500) why.push('Ohne ' + ex.map(function (x) { return PROT_LABEL[x]; }).join(', '));
      if (a.excl.indexOf('grain') >= 0) {
        if (r.grainFree === true) { s += 15; why.push('Getreidefrei'); }
        else if (r.grainFree === false) s -= 1000;
        else { s -= 40; warn.push('Zutatenliste auf Getreide prüfen'); }
      }
      if (s > -500) out.push({ r: r, score: s, why: why, warn: warn });
    });
    out.sort(function (x, y) { return y.score - x.score || x.r.order - y.r.order; });
    return out;
  }

  /* ===== ZUSTAND ===== */
  function fresh() {
    return { age: 'adult', weight: 15, neutered: true,
      dryType: '370', wetType: '90', treatType: '350', dryKcal: 370, wetKcal: 90, treatKcal: 350,
      dryShare: 100, treats: false, dryPrice: 4, wetPrice: 3, weeks: 4,
      activity: 'mid', shape: 'ideal', digest: [], excl: [], wish: [] };
  }
  var KEY = 'mpc_fc_v1';
  var S = fresh(), tab = 'calc', mstep = 0, done = false;
  var MQ = [
    { title: 'Verdauung', sub: 'Gibt es etwas, worauf wir achten sollen?' },
    { title: 'Das verträgt er nicht', sub: 'Alles, was dein Hund nicht bekommen soll.' },
    { title: 'Das ist dir wichtig', sub: 'Optional. Mehrfachauswahl möglich.' }
  ];
  function save() { try { sessionStorage.setItem(KEY, JSON.stringify({ S: S, tab: tab, mstep: mstep, done: done })); } catch (e) {} }
  function load() {
    try {
      var j = JSON.parse(sessionStorage.getItem(KEY));
      if (j && j.S) { S = Object.assign(fresh(), j.S); tab = j.tab === 'match' ? 'match' : 'calc'; mstep = Math.min(2, Math.max(0, j.mstep | 0)); done = !!j.done; }
    } catch (e) {}
  }

  /* ===== TRACKING (dataLayer, Consent regelt der GTM) ===== */
  var fired = {};
  function track(name, data, once) {
    if (once && fired[name]) return;
    fired[name] = true;
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, data || {})); } catch (e) {}
  }

  /* ===== HELFER ===== */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function n(x, d) { return x.toLocaleString('de-DE', { maximumFractionDigits: d == null ? 0 : d }); }
  function eur(x) { return x.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function $(id) { return document.getElementById('fc-' + id); }
  function opts(key, list, multi) {
    return '<div class="opts">' + list.map(function (o) {
      var on = multi ? S[key].indexOf(o[0]) >= 0 : S[key] === o[0];
      return '<button type="button" class="opt" data-k="' + key + '" data-v="' + o[0] + '" data-m="' + (multi ? 1 : 0) + '" aria-pressed="' + on + '">' + esc(o[1]) + (o[2] ? '<small>' + esc(o[2]) + '</small>' : '') + '</button>';
    }).join('') + '</div>';
  }
  function kcalField(wrap, custom, label, sel, list, typeKey, inId, kcalKey, lo, hi) {
    return '<div class="field" id="fc-' + wrap + '"><label class="label" for="fc-' + sel + '">' + label + '</label>' +
      '<select id="fc-' + sel + '">' + list.map(function (o) { return '<option value="' + o[0] + '"' + (S[typeKey] === o[0] ? ' selected' : '') + '>' + o[1] + '</option>'; }).join('') + '</select>' +
      '<div id="fc-' + custom + '" class="field"><input type="number" id="fc-' + inId + '" inputmode="decimal" min="' + lo + '" max="' + hi + '" value="' + S[kcalKey] + '" aria-label="kcal pro 100 g">' +
      '<p class="note">Steht auf der Packung als „Energiegehalt“ oder „ME“. Bei Angabe pro kg einfach durch 10 teilen: 3.700 kcal pro kg sind 370 kcal pro 100 g.</p></div>' +
      '<p class="note" id="fc-' + custom + 'n">Weißt du es nicht? Der Standardwert reicht für eine gute erste Schätzung.</p></div>';
  }

  /* ===== REITER 1: FUTTERRECHNER ===== */
  function renderCalc() {
    app.innerHTML = '<div class="card">' +
      '<div><h2>Wie viel Futter braucht dein Hund?</h2><p class="lead">Funktioniert mit jedem Futter. Trag Energiegehalt und Preis von deinem aktuellen Futter ein, die Werte findest du auf der Packung.</p></div>' +
      '<fieldset><legend>Wie alt ist er?</legend>' + opts('age', [['puppy', 'Welpe oder Junghund', 'bis 12 Monate'], ['adult', 'Erwachsen', '1 bis 7 Jahre'], ['senior', 'Senior', 'ab 8 Jahren']]) + '</fieldset>' +
      '<div class="grid2"><div class="field"><label class="label" for="fc-weight">Gewicht in kg</label><input type="number" id="fc-weight" inputmode="decimal" min="1" max="100" step="0.5" value="' + S.weight + '"><input type="range" id="fc-weightr" min="2" max="70" step="1" value="' + Math.min(70, Math.max(2, S.weight)) + '" aria-label="Gewicht einstellen"></div>' +
      '<fieldset><legend>Kastriert?</legend>' + opts('neutered', [[true, 'Ja'], [false, 'Nein']]) + '</fieldset></div>' +
      '<fieldset><legend>Wie aktiv ist er?</legend>' + opts('activity', [['low', 'Ruhig', 'Spaziergänge, viel Sofa'], ['mid', 'Alltag', 'Täglich 1 bis 2 Stunden'], ['high', 'Sportlich', 'Hundesport, Joggen, Arbeitshund']]) + '</fieldset>' +
      '<fieldset><legend>Wie ist seine Figur?</legend>' + opts('shape', [['lean', 'Eher schlank'], ['ideal', 'Ideal', 'Rippen fühlbar, Taille sichtbar'], ['heavy', 'Etwas zu viel']]) + '</fieldset>' +
      '<div class="sub"><h3>Dein Futter</h3>' +
      '<div class="field"><label class="label" for="fc-share">Wie fütterst du? <span id="fc-shareval"></span></label><input type="range" id="fc-share" min="0" max="100" step="10" value="' + S.dryShare + '"><div class="rangescale"><span>nur Nassfutter</span><span>nur Trockenfutter</span></div></div>' +
      kcalField('dryF', 'dryCustom', 'Welches Trockenfutter fütterst du?', 'dryType', [['330', 'Light oder Senior, ca. 330 kcal pro 100 g'], ['370', 'Standard, ca. 370 kcal pro 100 g'], ['410', 'Energiereich oder Sport, ca. 410 kcal pro 100 g'], ['custom', 'Ich kenne den genauen Wert']], 'dryType', 'dryKcal', 'dryKcal', 100, 600) +
      kcalField('wetF', 'wetCustom', 'Welches Nassfutter fütterst du?', 'wetType', [['70', 'Leicht, ca. 70 kcal pro 100 g'], ['90', 'Standard, ca. 90 kcal pro 100 g'], ['110', 'Reichhaltig, ca. 110 kcal pro 100 g'], ['custom', 'Ich kenne den genauen Wert']], 'wetType', 'wetKcal', 'wetKcal', 30, 300) +
      '<fieldset><legend>Bekommt er Leckerlis?</legend>' + opts('treats', [[true, 'Ja', 'Rechnen wir mit 10 % der Energie'], [false, 'Nein']]) + '</fieldset>' +
      kcalField('treatwrap', 'treatCustom', 'Was für Leckerlis gibst du?', 'treatType', [['300', 'Kauartikel, ca. 300 kcal pro 100 g'], ['350', 'Standard-Snacks, ca. 350 kcal pro 100 g'], ['400', 'Getrocknetes Fleisch, ca. 400 kcal pro 100 g'], ['custom', 'Ich kenne den genauen Wert']], 'treatType', 'treatKcal', 'treatKcal', 50, 800) +
      '<div class="grid2"><div class="field" id="fc-dryPriceF"><label class="label" for="fc-dryPrice">Preis Trockenfutter, € pro kg</label><input type="number" id="fc-dryPrice" inputmode="decimal" min="0" step="0.1" value="' + S.dryPrice + '"></div>' +
      '<div class="field" id="fc-wetPriceF"><label class="label" for="fc-wetPrice">Preis Nassfutter, € pro kg</label><input type="number" id="fc-wetPrice" inputmode="decimal" min="0" step="0.1" value="' + S.wetPrice + '"></div></div>' +
      '<p class="note">Preise sind Beispielwerte. Bitte durch die Preise deines Futters ersetzen.</p></div></div>' +
      '<div class="card" id="fc-calcres"></div>';
    updateCalc();
  }
  function setHidden(id, h) { var el = $(id); if (el) el.hidden = h; }
  function updateCalc() {
    $('shareval').textContent = S.dryShare + ' % Trocken, ' + (100 - S.dryShare) + ' % Nass';
    setHidden('treatwrap', !S.treats);
    setHidden('dryF', S.dryShare === 0); setHidden('dryPriceF', S.dryShare === 0);
    setHidden('wetF', S.dryShare === 100); setHidden('wetPriceF', S.dryShare === 100);
    setHidden('dryCustom', S.dryType !== 'custom'); setHidden('dryCustomn', S.dryType === 'custom');
    setHidden('wetCustom', S.wetType !== 'custom'); setHidden('wetCustomn', S.wetType === 'custom');
    setHidden('treatCustom', S.treatType !== 'custom'); setHidden('treatCustomn', S.treatType === 'custom');
    var c = calcAll(S), wk = S.weeks, d = wk * 7;
    var showDry = S.dryShare > 0, showWet = S.dryShare < 100;
    function row(label, f) { return '<tr><td>' + label + '</td>' + ['low', 'mid', 'high'].map(function (k) { return '<td class="' + (k === S.activity ? 'mid' : '') + '">' + f(c[k]) + '</td>'; }).join('') + '</tr>'; }
    var cur = c[S.activity], parts = [];
    if (showDry) parts.push('<span><b>' + n(cur.dry) + ' g</b> Trockenfutter</span>');
    if (showWet) parts.push('<span><b>' + n(cur.wet) + ' g</b> Nassfutter</span>');
    if (S.treats) parts.push('<span><b>' + n(cur.treat) + ' g</b> Leckerlis</span>');
    var h = '<div class="answer"><div class="eyebrow">Das fütterst du pro Tag</div><div class="big">' + parts.join('') + '</div>' +
      '<p class="lead">Das sind ' + n(cur.kcal) + ' kcal für ' + n(S.weight, 1) + ' kg, ' + AGE_LABEL[S.age] + (S.neutered ? ', kastriert' : ', nicht kastriert') + ', ' + ACT_LABEL[S.activity] + ', Figur ' + SHAPE_LABEL[S.shape] + '. Verteile die Menge auf zwei Mahlzeiten. Kosten: ca. ' + eur(cur.cost) + ' pro Tag.</p></div>' +
      '<h3>Alle Aktivitätsstufen im Vergleich</h3>' +
      '<div class="tblwrap"><table><thead><tr><th></th><th class="' + (S.activity === 'low' ? 'mid' : '') + '">Ruhig</th><th class="' + (S.activity === 'mid' ? 'mid' : '') + '">Alltag</th><th class="' + (S.activity === 'high' ? 'mid' : '') + '">Sportlich</th></tr></thead><tbody>' +
      '<tr class="grp"><td colspan="4">Pro Tag</td></tr>' +
      row('Energie', function (x) { return '<b>' + n(x.kcal) + '</b> kcal'; }) +
      (showDry ? row('Trockenfutter', function (x) { return n(x.dry) + ' g'; }) : '') +
      (showWet ? row('Nassfutter', function (x) { return n(x.wet) + ' g'; }) : '') +
      (S.treats ? row('Leckerlis', function (x) { return n(x.treat) + ' g'; }) : '') +
      row('Kosten', function (x) { return eur(x.cost); }) +
      '<tr class="grp"><td colspan="4">Bedarf für <select id="fc-weeks" aria-label="Zeitraum in Wochen" class="inline">' + [2, 3, 4, 6, 8, 12].map(function (w) { return '<option value="' + w + '"' + (w === wk ? ' selected' : '') + '>' + w + ' Wochen</option>'; }).join('') + '</select></td></tr>' +
      (showDry ? row('Trockenfutter', function (x) { return n(x.dry * d / 1000, 1) + ' kg'; }) : '') +
      (showWet ? row('Nassfutter', function (x) { return n(x.wet * d / 1000, 1) + ' kg<br><span class="note">' + Math.ceil(x.wet * d / 400) + ' Dosen à 400 g</span>'; }) : '') +
      (S.treats ? row('Leckerlis', function (x) { return n(x.treat * d) + ' g'; }) : '') +
      row('Kosten', function (x) { return eur(x.cost * d); }) +
      '</tbody></table></div>' +
      (S.age === 'puppy' ? '<p class="warnbox">Welpen wachsen schnell, der Bedarf ändert sich fast monatlich. Wiege regelmäßig und stimme die Menge mit der Tierarztpraxis ab.</p>' : '') +
      '<p class="note">Berechnet über den Ruheenergiebedarf (70 × kg hoch 0,75) mal Faktor für Alter, Kastration, Aktivität und Figur. Ein Richtwert: Gewicht und Figur deines Hundes sind der beste Maßstab. Bei Krankheit oder Übergewicht bitte mit der Tierarztpraxis abstimmen.</p>' +
      (RECIPES.length ? '<div class="nav"><span class="note">Welches Futter zu deinen Werten passt, siehst du im nächsten Schritt.</span><button type="button" class="btn primary" data-go="match">Passendes Futter finden</button></div>' : '');
    $('calcres').innerHTML = h;
  }

  /* ===== REITER 2: PASSENDES FUTTER ===== */
  function carry() {
    return '<div class="carry"><span>Aus dem Futterrechner: <b>' + n(S.weight, 1) + ' kg</b>, ' + AGE_LABEL[S.age] + ', ' + (S.neutered ? 'kastriert' : 'nicht kastriert') + ', ' + ACT_LABEL[S.activity] + ', Figur ' + SHAPE_LABEL[S.shape] + '</span><button type="button" data-go="calc">Ändern</button></div>';
  }
  function mbody() {
    if (mstep === 0) return '<fieldset><legend>Gibt es Besonderheiten bei der Verdauung? <span class="hint">Mehrfachauswahl</span></legend>' + opts('digest', [['stomach', 'Empfindlicher Magen'], ['intol', 'Bekannte Unverträglichkeit'], ['purin', 'Tierarzt empfiehlt purinarme Fütterung']], true) + '<p class="note">Nichts ausgewählt heißt: keine Besonderheiten.</p></fieldset>';
    if (mstep === 1) return '<fieldset><legend>Worauf soll dein Hund verzichten? <span class="hint">Mehrfachauswahl</span></legend>' + opts('excl', [['gefluegel', 'Geflügel', 'Huhn, Pute, Ente'], ['lamm', 'Lamm'], ['fisch', 'Fisch'], ['rind', 'Rind'], ['insekt', 'Insekten'], ['hirsch', 'Hirsch'], ['grain', 'Getreide']], true) + '<p class="note">Nichts ausgewählt heißt: keine bekannten Probleme.</p></fieldset>';
    return '<fieldset><legend>Was ist dir beim Futter wichtig? <span class="hint">Optional</span></legend>' + opts('wish', [['single', 'Single-Protein', 'Nur eine tierische Proteinquelle'], ['cold', 'Kaltgepresst'], ['vegan', 'Fleischfrei']], true) + '</fieldset>';
  }
  function renderMatch() {
    if (done) return renderResult();
    var seg = ''; for (var i = 0; i < 3; i++) seg += '<span class="' + (i <= mstep ? 'on' : '') + '"></span>';
    app.innerHTML = '<div class="card">' + carry() + '<div class="progress">' + seg + '</div><div class="stepmeta">Schritt ' + (mstep + 1) + ' von 3</div>' +
      '<div><h2>' + MQ[mstep].title + '</h2><p class="lead">' + MQ[mstep].sub + '</p></div>' + mbody() +
      '<div class="nav"><button type="button" class="btn ghost" data-act="mback"' + (mstep === 0 ? ' hidden' : '') + '>Zurück</button><button type="button" class="btn primary" data-act="mnext">' + (mstep === 2 ? 'Ergebnis anzeigen' : 'Weiter') + '</button></div></div>';
  }
  function thumb(r, cls) { return r.image ? '<img class="' + cls + '" src="' + esc(r.image) + '" alt="' + esc(r.name) + '" loading="lazy" width="96" height="96">' : ''; }
  var lastTop = null;
  function renderResult() {
    var list = rank(S), kcal = dailyKcal(S), h = '';
    if (!list.length) {
      app.innerHTML = '<div class="card">' + carry() + '<h2>Dafür haben wir keine passende Sorte</h2><p class="lead">Mit diesen Ausschlüssen bleibt keine Sorte übrig. Schreib uns kurz, wir suchen gemeinsam eine Lösung.</p><div class="nav"><button type="button" class="btn ghost" data-act="again">Fragen neu beantworten</button></div></div>';
      return;
    }
    var top = list[0], r = top.r, g = dailyGrams(kcal, r), warns = top.warn.slice();
    lastTop = r;
    if (S.age === 'puppy' || S.shape === 'heavy') warns.push('Bei Welpen im Wachstum und bei Übergewicht Menge mit der Tierarztpraxis abstimmen.');
    if (r.est) warns.push('Für diese Sorte ist der Energiewert noch nicht hinterlegt, die Menge ist geschätzt.');
    h += '<div class="card match">' + carry() + '<div class="mhead">' + thumb(r, 'mimg') + '<div><div class="eyebrow">Dein Match</div><h2 class="mname">' + esc(r.name) + '</h2><p class="lead">' + esc(r.line) + '</p></div></div>';
    if (top.why.length) h += '<div class="chips">' + top.why.map(function (w) { return '<span class="chip">' + esc(w) + '</span>'; }).join('') + '</div>';
    h += '<div class="stats"><div class="stat"><b>' + n(kcal) + ' kcal</b><span>Tagesbedarf</span></div><div class="stat"><b>ca. ' + n(g) + ' g</b><span>' + esc(r.name) + ' pro Tag</span></div></div>';
    if (S.dryShare === 100 && S.dryKcal > 0) h += '<p class="note">Zum Vergleich: Dein aktuelles Trockenfutter mit ' + n(S.dryKcal) + ' kcal pro 100 g wären ' + n(gramsFor(kcal, S.dryKcal)) + ' g pro Tag.</p>';
    warns.forEach(function (w) { h += '<p class="warnbox">' + esc(w) + '</p>'; });
    h += '<p class="note">Richtwert für ' + n(S.weight, 1) + ' kg. Die Fütterungsempfehlung auf der Packung hat Vorrang. Verteile die Menge auf zwei Mahlzeiten.</p>';
    h += '<a class="btn primary" data-fc-product="' + esc(r.key) + '" data-pos="1" href="' + esc(r.url) + '">' + esc(r.name) + ' ansehen' + (r.price ? ' (ab ' + esc(r.price) + ')' : '') + '</a></div>';
    var alts = list.slice(1, 3);
    if (alts.length) {
      h += '<div class="card"><h2>Weitere Möglichkeiten</h2>' + alts.map(function (x, i) {
        return '<div class="alt">' + thumb(x.r, 'aimg') + '<div class="altt"><b>' + esc(x.r.name) + '</b><br><span class="note">' + esc(x.r.line) + ' · ca. ' + n(dailyGrams(kcal, x.r)) + ' g pro Tag' + (x.r.est ? ' (geschätzt)' : '') + '</span></div><a data-fc-product="' + esc(x.r.key) + '" data-pos="' + (i + 2) + '" href="' + esc(x.r.url) + '">Ansehen</a></div>';
      }).join('') + '</div>';
    }
    if (root.querySelector('template[data-mpc-fc-mail]')) h += '<div class="card mail" id="fc-mailslot"></div>';
    h += '<div class="nav"><button type="button" class="btn ghost" data-act="again">Fragen neu beantworten</button></div>';
    app.innerHTML = h;
    var tpl = root.querySelector('template[data-mpc-fc-mail]'), slot = $('mailslot');
    if (tpl && slot) slot.appendChild(tpl.content.cloneNode(true));
    track('fc_match_result', { fc_recipe: r.key, fc_age: S.age });
  }

  /* ===== STEUERUNG ===== */
  function show(t, scroll) {
    tab = t;
    root.querySelectorAll('.mpc-fc__tab').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === t ? 'true' : 'false'); });
    if (t === 'calc') renderCalc(); else renderMatch();
    try { history.replaceState(null, '', t === 'match' ? '#futter-check' : '#rechner'); } catch (e) {}
    if (scroll) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    save();
  }
  function num(id, key, lo, hi) {
    var v = parseFloat(String($(id).value).replace(',', '.'));
    if (isFinite(v) && v >= lo && v <= hi) { S[key] = v; return true; }
    return false;
  }
  function parseV(v) { return v === 'true' ? true : v === 'false' ? false : v; }

  root.addEventListener('click', function (e) {
    var tabBtn = e.target.closest('.mpc-fc__tab');
    if (tabBtn) { show(tabBtn.getAttribute('data-tab'), false); return; }
    var link = e.target.closest('a[data-fc-product]');
    if (link) { track('fc_product_click', { fc_recipe: link.getAttribute('data-fc-product'), fc_position: +link.getAttribute('data-pos') }); return; }
    var t = e.target.closest('button'); if (!t || !app.contains(t)) return;
    if (t.classList.contains('opt')) {
      var k = t.getAttribute('data-k'), v = parseV(t.getAttribute('data-v'));
      if (t.getAttribute('data-m') === '1') { var i = S[k].indexOf(v); if (i >= 0) S[k].splice(i, 1); else S[k].push(v); }
      else S[k] = v;
      t.parentNode.querySelectorAll('.opt').forEach(function (b) {
        var bv = parseV(b.getAttribute('data-v'));
        b.setAttribute('aria-pressed', t.getAttribute('data-m') === '1' ? S[k].indexOf(bv) >= 0 : S[k] === bv);
      });
      if (tab === 'calc') { updateCalc(); track('fc_calc_start', null, true); }
      save();
    } else if (t.getAttribute('data-go')) {
      var go = t.getAttribute('data-go');
      if (go === 'match') track('fc_calc_cta', { fc_age: S.age, fc_weight: S.weight });
      show(go, true);
    } else if (t.getAttribute('data-act') === 'mnext') {
      if (mstep === 2) { done = true; renderMatch(); } else { mstep++; renderMatch(); track('fc_match_step', { fc_step: mstep + 1 }); }
      save(); root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else if (t.getAttribute('data-act') === 'mback') { mstep--; renderMatch(); save(); }
    else if (t.getAttribute('data-act') === 'again') { done = false; mstep = 0; renderMatch(); save(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });
  root.addEventListener('input', function (e) {
    var id = e.target.id; if (id.indexOf('fc-') !== 0) return;
    id = id.slice(3);
    if (id === 'weight') { if (num('weight', 'weight', 1, 100)) { $('weightr').value = Math.min(70, Math.max(2, S.weight)); updateCalc(); } }
    else if (id === 'weightr') { S.weight = +e.target.value; $('weight').value = S.weight; updateCalc(); }
    else if (id === 'share') { S.dryShare = +e.target.value; updateCalc(); }
    else if (id === 'dryKcal') { if (num(id, 'dryKcal', 50, 800)) updateCalc(); }
    else if (id === 'wetKcal') { if (num(id, 'wetKcal', 20, 400)) updateCalc(); }
    else if (id === 'treatKcal') { if (num(id, 'treatKcal', 50, 800)) updateCalc(); }
    else if (id === 'dryPrice') { if (num(id, 'dryPrice', 0, 100)) updateCalc(); }
    else if (id === 'wetPrice') { if (num(id, 'wetPrice', 0, 100)) updateCalc(); }
    else return;
    track('fc_calc_start', null, true); save();
  });
  root.addEventListener('change', function (e) {
    var id = e.target.id, v = e.target.value; if (id.indexOf('fc-') !== 0) return;
    id = id.slice(3);
    if (id === 'weeks') S.weeks = +v;
    else if (id === 'dryType' || id === 'wetType' || id === 'treatType') {
      var base = id.replace('Type', '');
      S[id] = v;
      if (v !== 'custom') { S[base + 'Kcal'] = +v; $(base + 'Kcal').value = S[base + 'Kcal']; }
    } else return;
    updateCalc(); track('fc_calc_start', null, true); save();
  });
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('form'); if (!form || form.id !== 'mpc-fc-form') return;
    e.preventDefault();
    var msg = form.querySelector('[data-fc-msg]'), btn = form.querySelector('button[type=submit]');
    var tagsEl = form.querySelector('input[name="contact[tags]"]');
    if (tagsEl) tagsEl.value = ['futter-check', 'fc-' + (lastTop ? lastTop.key : 'x'), 'fc-' + S.age].join(',');
    btn.disabled = true;
    fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
      .then(function (res) {
        if (!res.ok) throw new Error('status ' + res.status);
        msg.hidden = false; msg.textContent = 'Danke, du bist eingetragen. Wir melden uns per E-Mail.';
        track('fc_email_submit', { fc_recipe: lastTop ? lastTop.key : '' });
      })
      .catch(function () { btn.disabled = false; msg.hidden = false; msg.textContent = 'Das hat leider nicht geklappt. Bitte versuch es in ein paar Minuten noch einmal.'; });
  });

  /* ===== START ===== */
  load();
  if (location.hash === '#futter-check') tab = 'match';
  else if (location.hash === '#rechner') tab = 'calc';
  show(tab, false);
})();
